// @flow
import moment from "moment";

import type { ChartType } from "../../../global/types/BillingChartType";

export function shortProduct(product: *): * {
  let json = {};

  json.id = product.id;
  json.uuid = product.uuid;
  json.year = product.year;
  json.month = product.month;

  json.date = moment(product.month, "M").format("MMMM") + " " + product.year;

  let prices = [];
  {
    product.customerPrices.edges &&
      product.customerPrices.edges.map(
        (node: *, j: number): * => {
          prices.push({
            id: node.node.id,
            price: node.node.price,
            name: node.node.part.name,
            partNo: node.node.part.partNo
          });
        }
      );
  }

  json.prices = prices;

  return json;
}

export function calculateDatabaseSizePerHour(basePrice: string): string {
  if (!basePrice || isNaN(basePrice)) {
    return "";
  } else {
    return ((parseFloat(basePrice) / 365 / 24) * 10000).toFixed(4);
  }
}

export function AppendHelpInfo(charts: Array<ChartType>): Array<ChartType> {
  let json = [...charts];
  charts.map(
    (chart: ChartType, i: number): * => {
      if (chart.id === "IMQ-CL-005a") {
        chart.help =
          "Enjoy 2 free counts for each verification request, 1 free count for each search or enrolment request.";
      } else if (chart.id === "IMQ-CL-005") {
        chart.help =
          "This figure is derived by subtracting the Free Detection Count from the total count of detection requests.";
      } else if (chart.id === "IMQ-CL-001") {
        chart.help = "This figure is the total sum of all faces in each hour.";
      }

      if (chart.id === "IMQ-CL-001") {
        chart.displayPrice =
          "$" +
          (parseFloat(chart.price) * 10000).toFixed(4) +
          " per 10,000 Faces per Hour";
      } else {
        chart.displayPrice =
          "$" + parseFloat(chart.price).toFixed(4) + " per Request";
      }
    }
  );

  return charts;
}
